<div @fade class="barcode-details-section">
    <div *ngIf="displayLoader">
        <div class="loader-div">
            <div class="loader"></div>
        </div>
    </div>
    <div *ngIf="barcode">
      <div class="barcode-image-section m10t-border">
          <img src="{{barcode.base64ImageStr}}" alt="barcode image"/>
      </div>
      <div class="user-details-section">
          <div class=" m10t-border">
              <div class="user-name">
                  <label class="m10t-label1">Authorised user</label>
                  <p class="m10t-text2 w600">{{barcode.accountSummary.authorisedUser}}</p>
              </div>
              <div class="user-name">
                  <label class="m10t-label1 ">Account code</label>
                  <p class="m10t-text2">{{barcode.accountSummary.accountCode}}</p>
              </div>        
          </div>
          <div *ngIf="barcode.accountSummary.ruleType === '05' && (barcode.accountSummary.storeName || barcode.accountSummary.chargeAccountContactPhone)" class="user-store-section m10t-margin-top">
              <label class="m10t-label1">Home store</label>
              <div class="store-name" *ngIf="barcode.accountSummary.storeName">
                  <p class="m10t-text2 w600">{{barcode.accountSummary.storeName}}</p>
              </div>       
          </div>
      </div>
  </div>
  <div *ngIf="errorBlock" class="error-div">
      <p>There seems to be a problem loading your SmartMate barcode. Please contact your company manager / administrator to re-send the barcode to your mobile. If the issue persists, please ask your company manager to submit a request via the Help menu in Trade Hub or e-mail <a href="mailto:smartmate@mitre10.co.nz">smartmate@mitre10.co.nz</a> for assistance. Thank you.</p>
  </div>
</div>
